import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';
import Announce from '@/types/Announce.type';
import { Departments } from '@/types/Department.type';

type Props = {
  onEdit: (id: number) => void;
  onDelete: (id: number, number: string) => void;
  rows: Array<Announce & Departments>;
};

const AnnounceTableBody: React.FC<Props> = ({ onEdit, onDelete, rows }) => {
  return (
    <TableBody>
      {rows.map((row) => (
        <TableRow key={row.id}>
          <TableCell>{row.title}</TableCell>
          <TableCell>{`${row.startDate} ~ ${row.endDate ?? ''}`}</TableCell>
          <TableCell>
            {row.departments.map((department, index) => (
              <React.Fragment key={index}>
                {department.name}
                <br />
              </React.Fragment>
            ))}
          </TableCell>
          <TableCell>
            <IconButton onClick={() => onEdit(row.id)}>
              <EditIcon />
            </IconButton>
            <IconButton onClick={() => onDelete(row.id, row.title)}>
              <DeleteIcon />
            </IconButton>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};
export default AnnounceTableBody;
